module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '7i63sk9u',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
